import { AppRoutes, buildRoute } from '@/route/routeConfig';
import { NotificationResources } from '../types/notification';

export const getTerminalRoutes = ({ resourceType, resourceTypeId }: IGetPlatformRoutes): string => {
  switch (resourceType) {
    case NotificationResources.Account:
      return buildRoute(AppRoutes.SETTINGS_COMPANY);
    case NotificationResources.User:
      return buildRoute(AppRoutes.ADMIN_USER_DETAIL, { userId: resourceTypeId });
    case NotificationResources.Title:
      return buildRoute(AppRoutes.ADMIN_ORG_TITLES);
    default:
      throw new Error('resource type not recognized for terminal');
  }
};
